module.exports = __webpack_public_path__ + "static/media/apple-badge.26fd527d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/apple-badge.png
// module id = 60
// module chunks = 4